import http from "../../http"
import {API_V1_URL} from "../../constants/other"


const NEWCOINS_BALANCE_URL = `${API_V1_URL}/newcoins-transactions/newcoins-balances`

export const getNewcoinsBalances = (params, cancelToken) => http.get(NEWCOINS_BALANCE_URL, {params}, {}, cancelToken)


